export const LOAD_PROJECTS = 'load_projects';
export const PROJECTS_FAILED = 'loading_projects_has_failed';
export const PROJECTS_LOADED = 'set_loaded_projects';
